import { Button } from "components/button";
import { WrapSectionLayout } from "components/common";
import { DropdownSearch } from "components/dropdownSearch";
import { Input } from "components/input";
import InputDatePicker from "components/input/InputDatePicker";
import { Kanban } from "components/kanban";
import { FakeData } from "constants/FakeData";
import { useMountTransition } from "hooks/useMountTransition";
import { ItemKanbanLeadDetail } from "modules/lead/leadKanban";
import { KanbanItem } from "modules/revenuePlan";
import { TitleDashboard } from "modules/titleDashboard";
import React from "react";
import { useForm } from "react-hook-form";
import { useSelector } from "react-redux";

const RevenuePlanPage = () => {
	const {
		control,
		formState: { errors, isValid, isSubmitting },
	} = useForm({
		mode: "onChange",
	});
	const showDetail = useSelector(state => state.kanban.showDetail);
	const hasTransitionedIn = useMountTransition(showDetail, 1000);
	return (
		<WrapSectionLayout className='section-list-revenue'>
			<div className='board-white'>
				<TitleDashboard typeExport typeDelete>
					Kế hoạch thu
				</TitleDashboard>
				<form className='wrap-form'>
					<div className='flex mt-3 gap-x-30px items-end flex-col sm:flex-row'>
						<div className='flex w-full sm:flex-1 sm:mb-0'>
							<div className='grid gap-y-24px md:grid-cols-4 lg:grid-cols-[2fr_1fr_1fr_1fr] md:gap-x-20px lg:gap-x-40px w-full'>
								<Input
									label='Tìm kiếm (tên)'
									control={control}
									name='SearchName'></Input>
								<DropdownSearch
									label='PM Thiết kế'
									control={control}
									name='PmThietKe'
									data={FakeData.Level}></DropdownSearch>
								<DropdownSearch
									label='PM Thiết kế'
									name='PmThietKe'
									control={control}
									data={FakeData.Level}></DropdownSearch>
								<DropdownSearch
									label='PM Thiết kế'
									control={control}
									name='PmThietKe'
									data={FakeData.Level}></DropdownSearch>
							</div>
						</div>
						<div className='hidden sm:block'>
							<Button kind='filter'></Button>
						</div>
					</div>
					<div className='flex gap-x-30px items-start mt-7 flex-col lg:flex-row'>
						<div className='flex flex-1 w-full sm:w-auto gap-y-24px sm:flex-row flex-col'>
							<div className='grid md:grid-cols-[1fr_1fr_1fr_1fr_1fr] gap-x-20px lg:gap-x-40px gap-y-24px w-full'>
								<DropdownSearch
									label='Project Status'
									name='ProjectStatus'
									data={FakeData.Level}
									control={control}></DropdownSearch>
								<DropdownSearch
									label='Tuần'
									name='week'
									control={control}
									data={FakeData.Level}></DropdownSearch>
								<InputDatePicker
									label='Từ Ngày'
									name='EndDate'
									control={control}></InputDatePicker>
								<InputDatePicker
									label='Đến Ngày'
									name='EndDate'
									control={control}></InputDatePicker>
								<div className='pms-total-income text-sm text-right lg:text-left'>
									<p>Tổng thu dự kiến</p>
									<p className='text-blue-2 text-base font-semibold'>
										2.500.000.000đ
									</p>
								</div>
							</div>
						</div>
						<div className='pms-total-income text-sm w-130px ml-auto lg:ml-0 text-right lg:text-left'>
							<p>Đã thu</p>
							<p className='text-primary text-base font-semibold'>
								2.500.000.000đ
							</p>
						</div>
					</div>
					<div className='sm:hidden block mt-20px'>
						<Button kind='filter'></Button>
					</div>
				</form>
				<div className='wrap-box-kanban mt-30px'>
					<Kanban data={FakeData.listDataKanban}>
						<KanbanItem></KanbanItem>
					</Kanban>
					{(hasTransitionedIn || showDetail) && (
						<ItemKanbanLeadDetail
							className={`${hasTransitionedIn && "in"} ${
								showDetail && "show"
							}`}></ItemKanbanLeadDetail>
					)}
				</div>
			</div>
		</WrapSectionLayout>
	);
};

export default RevenuePlanPage;
